const itemActions = ({
  showModal,
  showEditAudienceModal,
}: {
  showModal: (
    params: {
      isOpen: boolean;
      position: 'right' | 'center';
      selectedItem?: any;
      selectedItems?: any[];
      type?: string;
    },
    title: string
  ) => void;
  showEditAudienceModal: ({ audience }) => void;
}) => {
  return {
    move: (item: any) => {
      showModal(
        {
          isOpen: true,
          position: 'center',
          selectedItem: item,
        },
        'MoveItem'
      );
    },
    clone: (item: any) => {
      showModal(
        {
          isOpen: true,
          position: 'center',
          selectedItem: item,
        },
        'CloneAudience'
      );
    },
    save: (item: any) => {
      showModal(
        {
          isOpen: true,
          position: 'center',
          selectedItem: item,
        },
        'SaveAudience'
      );
    },
    delete: (items: any[], type: string) => {
      showModal(
        {
          isOpen: true,
          position: 'center',
          type,
          selectedItems: items,
        },
        'Delete'
      );
    },
    rename: (item: any) => {
      showModal(
        {
          isOpen: true,
          position: 'center',
          selectedItem: item,
        },
        'Rename'
      );
    },
    edit: (audience: any) => {
      showEditAudienceModal({ audience });
    },
    preview: (item: any) => {
      showModal(
        { isOpen: true, position: 'right', selectedItem: item },
        'AudiencePreview'
      );
    },
    share: (item: any) => {
      showModal(
        {
          isOpen: true,
          position: 'center',
          selectedItem: item,
        },
        'ShareAudience'
      );
    },
  };
};

export default itemActions;
